type Afdeling = {
    id: string;
    building: string;
    floor: string;
    wing?: string;
    name: string;
};

const normalize = (value: string) => value.trim().toLowerCase();
const compareText = (left: string, right: string) => left < right ? -1 : left > right ? 1 : 0;

// Locale-independent natural ordering, including floors larger than JS integers.
function compareNatural(left: string, right: string): number {
    const a = normalize(left).match(/[0-9]+|[^0-9]/g) ?? [];
    const b = normalize(right).match(/[0-9]+|[^0-9]/g) ?? [];
    for (let index = 0; index < Math.min(a.length, b.length); index++) {
        let order: number;
        if (/^[0-9]/.test(a[index]) && /^[0-9]/.test(b[index])) {
            const x = a[index].replace(/^0+/, '');
            const y = b[index].replace(/^0+/, '');
            order = x.length - y.length || compareText(x, y);
        } else {
            order = compareText(a[index], b[index]);
        }
        if (order) return order;
    }
    return a.length - b.length;
}

function wingRank(wing: string) {
    return ({ '': 0, east: 1, west: 2 } as Record<string, number>)[normalize(wing)] ?? 3;
}

// Keep in sync with backend/internal/ovd/afdeling.go: none, East, West,
// then other configured wings. All is a UI sentinel, never an OVD identity.
export function compareAfdelingen(left: Afdeling, right: Afdeling): number {
    const all = Number(normalize(right.id) === 'all') - Number(normalize(left.id) === 'all');
    return all
        || compareNatural(left.building, right.building)
        || compareNatural(left.floor, right.floor)
        || wingRank(left.wing ?? '') - wingRank(right.wing ?? '')
        || compareNatural(left.wing ?? '', right.wing ?? '')
        || compareNatural(left.name, right.name)
        || compareNatural(left.id, right.id)
        || compareText(left.id, right.id);
}

export function sortAfdelingen<T extends Afdeling>(options: readonly T[]): T[] {
    return [...options].sort(compareAfdelingen);
}
